import { Component, ChangeDetectionStrategy, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-not-found',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
    private platformId = inject(PLATFORM_ID);

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            window.location.href = '/not-found';
        }
    }
}
